import React, { PureComponent } from 'react';
import classNames from 'classnames';
import get from 'lodash/get';

import styles from './ButtonTabs.module.scss';

interface ButtonTabsProps {
  className?: string;
  activeTab?: string;
  tabsList: IActiveButtonTab[];
  onChange?: (value: string) => void; // IActiveButtonTab
  // TODO - объединить пропсы стилей в classNames
  classNames?: ButtonTabsClassNames;
  buttonTabTextColor?: string;
  buttonTabTextActiveColor?: string;
  buttonTabIconColor?: string;
  buttonTabIconActiveColor?: string;
}

interface ButtonTabsClassNames {
  buttonTabsContainer?: string;
  tabContainer?: string;
  tabContainerActive?: string;
  tabText?: string;
}

interface ButtonTabsState {
  activeTab: string | undefined;
  tabsList: IActiveButtonTab[];
}

export interface IActiveButtonTab {
  value: string;
  label: string;
  // active?: boolean;
  icon?: React.ElementType;
  title?: string;
  helper?: React.ReactNode;
}

// TODO - get theme color
const whiteColor = '#FFFFFF';
const blueColor = '#5DBDF9';

export default class ButtonTabs extends PureComponent<ButtonTabsProps, ButtonTabsState> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeTab: undefined,
      tabsList: [],
    };
  }

  public componentDidMount() {
    const { activeTab, tabsList } = this.props;
    this.setState({ activeTab: activeTab, tabsList }); // activeTab !== undefined ? activeTab : tabsList[0].value
  }

  public componentDidUpdate(prevProps: ButtonTabsProps) {
    const { activeTab, tabsList } = this.props;
    if (prevProps.tabsList !== tabsList || prevProps.activeTab !== activeTab) {
      this.setState({ activeTab: activeTab, tabsList });
    }
  }

  private readonly getTabIconColor = (isActive: boolean | undefined): string | undefined => {
    const { buttonTabIconColor, buttonTabIconActiveColor } = this.props;
    if (buttonTabIconColor || buttonTabIconActiveColor) {
      return isActive ? buttonTabIconActiveColor : buttonTabIconColor;
    }
    return isActive ? whiteColor : blueColor;
  };

  private readonly getTabTextColor = (isActive: boolean | undefined): string | undefined => {
    const { buttonTabTextColor, buttonTabTextActiveColor } = this.props;
    if (buttonTabTextColor || buttonTabTextActiveColor) {
      return isActive ? buttonTabTextActiveColor : buttonTabTextColor;
    }
    return isActive ? whiteColor : blueColor;
  };

  private readonly changeHandler = (index: number) => {
    const { tabsList } = this.state;
    const { onChange } = this.props;

    const activeTab = tabsList[index].value;
    this.setState({ activeTab: activeTab });
    if (onChange !== undefined) {
      onChange(activeTab);
    }
  };

  private readonly getTabsList = () => {
    const { activeTab, tabsList } = this.state;
    const tabContainer = get(this.props, 'classNames.tabContainer');
    const tabContainerActive = get(this.props, 'classNames.tabContainerActive');
    const tabText = get(this.props, 'classNames.tabText');

    return tabsList.map((item, index) => {
      return item.icon ? (
        <div
          key={`${index}${item.label}`}
          title={item.title ? item.title : undefined}
          className={classNames(
            tabContainer ? tabContainer : styles.button_tabs__div_button,
            // TODO - убрать стиль!
            styles.button_tabs__div_button__padding_top,
            {
              [tabContainerActive ? tabContainerActive : styles.button_tabs__div_button__active]:
                item.value === activeTab,
            }
          )}
          onClick={() => this.changeHandler(index)}
        >
          <div style={{ position: 'relative' }}>
            <div style={{ width: 20, height: 20 }}>
              {React.createElement(item.icon, {
                fill: this.getTabIconColor(item.value === activeTab),
              })}
            </div>
            {item.helper && (
              <div style={{ position: 'absolute', top: 0, right: 0 }}>{item.helper}</div>
            )}
          </div>
          <div className={tabText ? tabText : styles.button_tabs__span}>
            <span
              style={{
                color: this.getTabTextColor(item.value === activeTab),
              }}
            >
              {item.label}
            </span>
          </div>
        </div>
      ) : (
        <div
          key={`${index}${item.label}`}
          title={item.title ? item.title : undefined}
          className={classNames(tabContainer ? tabContainer : styles.button_tabs__div_button, {
            [tabContainerActive ? tabContainerActive : styles.button_tabs__div_button__active]:
              item.value === activeTab,
          })}
          onClick={() => this.changeHandler(index)}
        >
          <div className={tabText ? tabText : styles.button_tabs__span}>
            <span
              style={{
                color: this.getTabTextColor(item.value === activeTab),
              }}
            >
              {item.label}
            </span>
          </div>
        </div>
      );
    });
  };

  public render() {
    const { className } = this.props;
    const buttonTabsContainer = get(this.props, 'classNames.buttonTabsContainer');

    return (
      <div
        className={
          buttonTabsContainer ? buttonTabsContainer : classNames(styles.button_tabs, className)
        }
      >
        {this.getTabsList()}
      </div>
    );
  }
}
